import React, {useEffect, useState} from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Icon from '@material-ui/core/Icon';
import {withStyles} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import FormCheck from '../Form/FormCheck';
import {green, red} from "@material-ui/core/colors";
import FormField from "../Form/FormField";
import i18n from "../../i18n";
import GraphQlLoading from "../GraphQl/Loading";
import workTimeSymbolMutations from "../../mutations/workTimeSymbolMutations";
import {getMutationName} from "../Form/utils";
import configQueries from "../../queries/configQueries";
import _ from "lodash";

const saveSymbol = async (values) => {

    const mutation = values && values.id > 0 ? workTimeSymbolMutations.updateWorkTimeSymbol : workTimeSymbolMutations.createWorkTimeSymbol;
    const mutationName = getMutationName(mutation);

    if(mutation && mutationName){
        const {data: result} = await window.apolloClient.mutate({mutation, variables: {...values}})
            .catch((e) => { console.log('graphQLErrors', e ) });
        return result[mutationName];
    }
}

const deleteSymbol = async (symbol) => {

    const query = configQueries.deleteWorkTimeSymbol;
    const queryName = getMutationName(query);

    if(symbol.id) {
        let variables = { id: parseInt(symbol.id) };
        const {data:result} = await window.apolloClient.query({ query , variables, errorPolicy:'all'})
            .catch((e) => { console.log('graphQLErrors', e ) });
        return result[queryName];
    }

}

const SymbolEdit = (props) => {
    const { classes, setCanAdd } = props;

    const [values, setValues] = useState(props.values);
    const [edit, setEdit] = useState(props.edit || false);
    const [error, setError] = useState({acronym:false,name:false});
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        props.setReloading && props.setReloading(false);
    },[props])

    const handleDelete = () => {
        if(!values.id) {
            props.unmount(this);
        } else {
            deleteSymbol(values).then(async (res) => {
                if(res) {
                    props.setReloading(true);
                    props.unmount(res);
                }
            });
        }
    }

    const handleSubmit = (values) => {
        setSaving(true);
        saveSymbol(values).then((res) => {
            if(res) {
                setEdit(false);
                setValues(res);
                setSaving(false);
                setCanAdd(true);
            }
        });
    }

    return (saving
        ? <TableRow><TableCell colSpan={4}><GraphQlLoading/></TableCell></TableRow>
        : <TableRow>
            <TableCell scope="col">
                {edit ? (
                    <FormField
                        type={'text'}
                        name={'acronym'}
                        value={values.acronym}
                        touched={error.acronym}
                        error={error.acronym}
                        onChange={(e) => {
                            setValues({...values, acronym: e.target.value});
                        }}
                    />
                ) : (
                    values.acronym && values.acronym
                )}
            </TableCell>
            <TableCell scope="col">
                {edit ? (
                    <FormField
                        type={'text'}
                        name={'name'}
                        value={values.name && values.name}
                        touched={error.name}
                        error={error.name}
                        onChange={(e) => {
                            setValues({...values, name: e.target.value});
                        }}
                    />
                ) : (
                    values.name && values.name
                )}
            </TableCell>
            <TableCell scope="col">
                {edit
                    ? (<FormCheck
                        name={'record'}
                        value={values.record}
                        onChange={(e, chk) => {
                           setValues({...values, record: chk});
                        }}
                    />)
                    : values.record && <Icon className={classes.green}>check</Icon>
                }
            </TableCell>
            <TableCell scope="col">
                {edit ? (
                    <React.Fragment>
                        <IconButton
                            component={'a'}
                            onClick={() => {
                                setEdit(false);
                                setCanAdd(true);
                                setValues(values);
                                if(!values.id && !(values.acronym || values.name)) {
                                    props.unmount(this);
                                }
                            }}
                        >
                            <Icon>cancel</Icon>
                        </IconButton>

                        <IconButton
                            component={'a'}
                            onClick={() => {
                                if(!values.id && !(values.acronym && values.name)) {
                                    let err = error;
                                    for (let key in err) {
                                        err = {...err,[key]: !values[key] && i18n.get('config.work_time.please_fill_in')};
                                    }
                                    setError(err);
                                } else {
                                    setError({acronym:false,name:false});
                                    handleSubmit(values);
                                }
                            }}
                        >
                            <Icon>save</Icon>
                        </IconButton>

                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <IconButton
                            component={'a'}
                            onClick={handleDelete}
                        >
                            <Icon>delete</Icon>
                        </IconButton>

                        <IconButton
                            component={'a'}
                            onClick={() => {
                                setEdit(true);
                                setCanAdd(false);
                            }}
                        >
                            <Icon>edit</Icon>
                        </IconButton>
                        {!values.id && <span style={{marginLeft:10}} className={classes.red}>{'(not saved)'}</span>}
                    </React.Fragment>

                )}
            </TableCell>
        </TableRow>
    );
};

const styles = theme => ({
    green: {
        color: green[600],
    },
    red: {
        color: red[400],
    }
});

export default withStyles(styles)(SymbolEdit);
